import React, { useMemo } from 'react';
import Grid from "@mui/material/Grid";
import VuiBox from "components/ui/VuiBox";
import MiniStatCard, { MiniStatCardSkeleton } from "components/MiniStatCard";

// Import suitable icons
import { IoMegaphoneOutline, IoRocketOutline, IoPulseOutline, IoPodiumOutline } from "react-icons/io5"; // Example icons

function ProductInsightsStats({ topProductsData, loading }) {

  const stats = useMemo(() => {
    if (!topProductsData) {
      return {
        nbProductsAdvertised: 0,
        mostAdvertisedProduct: "N/A",
        nbProductPosts: 0,
      };
    }

    const nbProductsAdvertised = topProductsData.length;
    const mostAdvertisedProduct = nbProductsAdvertised > 0 ? topProductsData[0].productName : "No data";
    const nbProductPosts = topProductsData.reduce((sum, product) => sum + product.totalMentions, 0);

    return {
      nbProductsAdvertised,
      mostAdvertisedProduct,
      nbProductPosts,
    };
  }, [topProductsData]);

  if (loading && !topProductsData) {
    return (
      <VuiBox mb={3}>
        <Grid container spacing={3}>
          {[0, 1, 2, 3].map((i) => (
            <Grid key={i} item xs={12} md={6} xl={3}>
              <MiniStatCardSkeleton />
            </Grid>
          ))}
        </Grid>
      </VuiBox>
    );
  }

  const cardData = [
    {
      title: "Products Advertised",
      value: stats.nbProductsAdvertised,
      iconComponent: <IoPodiumOutline size="20px" color="white" />,
      iconColor: "info",
    },
    {
      title: "Most Advertised Product",
      value: stats.mostAdvertisedProduct,
      iconComponent: <IoRocketOutline size="20px" color="white" />,
      iconColor: "info", 
    },
    {
      title: "Total Product Mentions",
      value: stats.nbProductPosts.toLocaleString(), // Format number with commas
      iconComponent: <IoMegaphoneOutline size="20px" color="white" />,
      iconColor: "info",
    },
    {
      title: "Avg Product Sentiment",
      // TODO: replace with actual implementation
      value: "Positive", // Hardcoded as requested
      iconComponent: <IoPulseOutline size="20px" color="white" />,
      iconColor: "info",
    },
  ];

  return (
    <VuiBox mb={3}>
      <Grid container spacing={3}>
        {cardData.map((item, index) => (
          <Grid item xs={12} md={6} xl={3} key={index}>
            <MiniStatCard
              title={{ text: item.title }}
              count={item.value}
              icon={{
                color: item.iconColor,
                component: item.iconComponent,
              }}
            />
          </Grid>
        ))}
      </Grid>
    </VuiBox>
  );
}

export default ProductInsightsStats; 